const actions = {
    SALES_DASHBOARD_START: 'SALES_DASHBOARD_START',
    SALES_DASHBOARD_SUCCESS: 'SALES_DASHBOARD_SUCCESS',
    SALES_DASHBOARD_FAILURE: 'SALES_DASHBOARD_FAILURE',

    CUSTOMER_AGED_DUES_START: 'CUSTOMER_AGED_DUES_START',
    CUSTOMER_AGED_DUES_SUCCESS: 'CUSTOMER_AGED_DUES_SUCCESS',
    CUSTOMER_AGED_DUES_FAILURE: 'CUSTOMER_AGED_DUES_FAILURE',

    INACTIVE_CUSTOMERS_START: 'INACTIVE_CUSTOMERS_START',
    INACTIVE_CUSTOMERS_SUCCESS: 'INACTIVE_CUSTOMERS_SUCCESS',
    INACTIVE_CUSTOMERS_FAILURE: 'INACTIVE_CUSTOMERS_FAILURE',
};

export default actions;